import type { CmsSectionData } from './types';
export const defaultCmsSections: CmsSectionData[] = [
  {
    key: 'hero',
    title: '主視覺 Hero',
    isActive: true,
    sortOrder: 1,
    contentJson: {
      backgroundImage: '/images/hero-bg.jpg',
      foregroundImage: '/images/yuyangguan.png',
      eyebrow: {
        'zh-HK': '御陽罐【紅光專業版】',
        'zh-CN': '御阳罐【红光专业版】',
        en: 'Yu Yang Guan [Red Light Professional Edition]',
      },
      title: {
        'zh-HK': '深層透熱，擊碎頑固筋膜沾黏',
        'zh-CN': '深层透热，击碎顽固筋膜沾黏',
        en: 'Deep Penetrating Heat, Breaking Down Stubborn Fascial Adhesions',
      },
      subtitle: {
        'zh-HK': '天然砭石能量 × 現代紅光療法，從根源釋放深層痛症。看得見、即時有感的物理理療。',
        'zh-CN': '天然砭石能量 × 现代红光疗法，从根源释放深层痛症。看得见、即时有感的物理理疗。',
        en: 'Natural Bian Stone Energy × Modern Red Light Therapy. Release deep pain from the root. Visible, instantly felt physical therapy.',
      },
      trustText: {
        'zh-HK': '香港正貨・官方保養',
        'zh-CN': '香港正货・官方保养',
        en: 'Genuine Hong Kong Product · Official Warranty',
      },
      ctaText: {
        'zh-HK': '探索紅光專業版',
        'zh-CN': '探索红光专业版',
        en: 'Explore Red Light Professional Edition',
      },
      ctaHref: '/products/御陽砭石罐【專業版】',
      cta2Text: {
        'zh-HK': '瀏覽全系列',
        'zh-CN': '浏览全系列',
        en: 'Browse All Products',
      },
      cta2Href: '/products',
    },
  },
  {
    key: 'pain-tech',
    title: '痛點與科技',
    isActive: true,
    sortOrder: 2,
    contentJson: {
      painEyebrow: {
        'zh-HK': '痛點迷思',
        'zh-CN': '痛点迷思',
        en: 'The Pain Myth',
      },
      painTitle: {
        'zh-HK': '為何按摩總是反覆痠痛？',
        'zh-CN': '为何按摩总是反复酸痛？',
        en: 'Why does massage only give temporary relief?',
      },
      painDesc: {
        'zh-HK': '痛在肌肉，根在「筋膜」。表層推拿無法鬆解深層沾黏。御陽罐紅光專業版以特定波長紅光穿透表皮，直達深層筋膜，從根源改善痛症。',
        'zh-CN': '痛在肌肉，根在「筋膜」。表层推拿无法松解深层沾黏。御阳罐红光专业版以特定波长红光穿透表皮，直达深层筋膜，从根源改善痛症。',
        en: 'The pain is in the muscle, but the root is in the fascia. Surface massage cannot release deep adhesions. Yu Yang Guan Red Light Pro uses targeted red wavelengths to penetrate the skin and reach deep fascia.',
      },
      painImage: 'https://fuyangtong-api.jimsbond007.workers.dev/api/public/assets/media/7c6573ac-8e21-4d86-b5e5-e0035dfb45c8.jpg',
      techEyebrow: {
        'zh-HK': '科技解密',
        'zh-CN': '科技解密',
        en: 'The Science',
      },
      techTitle: {
        'zh-HK': '三重物理能量，深層鬆解',
        'zh-CN': '三重物理能量，深层松解',
        en: 'Three Physical Energies, Deep Release',
      },
      techItems: [
        {
          icon: 'red-light',
          title: {
            'zh-HK': '特定波長紅光',
            'zh-CN': '特定波长红光',
            en: 'Targeted Red Light',
          },
          desc: {
            'zh-HK': '穿透表皮直達深層，激發細胞 ATP 生成，降低發炎反應，促進組織修復。',
            'zh-CN': '穿透表皮直达深层，激发细胞 ATP 生成，降低发炎反应，促进组织修复。',
            en: 'Penetrates the epidermis to reach deep tissue, boosts cellular ATP production, reduces inflammation and accelerates repair.',
          },
        },
        {
          icon: 'stone-heat',
          title: {
            'zh-HK': '天然砭石溫熱',
            'zh-CN': '天然砭石温热',
            en: 'Natural Bianstone Heat',
          },
          desc: {
            'zh-HK': '結合恆溫透熱技術，軟化僵硬組織，釋放深層筋膜沾黏。',
            'zh-CN': '结合恒温透热技术，软化僵硬组织，释放深层筋膜沾黏。',
            en: 'Combines constant penetrating warmth to soften stiff tissue and release deep fascial adhesions.',
          },
        },
        {
          icon: 'vibration',
          title: {
            'zh-HK': '高頻微震鬆解',
            'zh-CN': '高频微震松解',
            en: 'High-Frequency Micro-Vibration',
          },
          desc: {
            'zh-HK': '物理打散沾黏筋膜，恢復肌肉彈性，讓痠痛不再反覆。',
            'zh-CN': '物理打散沾黏筋膜，恢复肌肉弹性，让酸痛不再反复。',
            en: 'Physically breaks up fascial adhesions and restores muscle elasticity, so pain does not keep coming back.',
          },
        },
      ],
    },
  },
  {
    key: 'pain-points',
    title: '痛點檢索',
    isActive: true,
    sortOrder: 3,
    contentJson: {
      eyebrow: {
        'zh-HK': '經絡與痛點檢索',
        'zh-CN': '经络与痛点检索',
        en: 'Meridian & Pain Point Finder',
      },
      titlePrefix: {
        'zh-HK': '點擊您的',
        'zh-CN': '点击您的',
        en: 'Click Your ',
      },
      titleAccent: {
        'zh-HK': '不適部位',
        'zh-CN': '不适部位',
        en: 'Discomfort Area',
      },
      subtitle: {
        'zh-HK': '獲取專屬養生建議，對症溫養',
        'zh-CN': '获取专属养生建议，对症温养',
        en: 'Get personalized wellness advice for targeted care',
      },
      suggest: {
        'zh-HK': '建議使用',
        'zh-CN': '建议使用',
        en: 'Recommended',
      },
      ctaText: {
        'zh-HK': '查看適用產品 →',
        'zh-CN': '查看适用产品 →',
        en: 'See recommended products →',
      },
      items: [
        {
          id: 'neck',
          iconSvg:
            '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="7" r="3.2" stroke="currentColor" stroke-width="1.6"/><path d="M6 21c0-4.5 3-7.5 6-7.5s6 3 6 7.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
          label: {
            'zh-HK': '肩頸酸痛',
            'zh-CN': '肩颈酸痛',
            en: 'Neck & Shoulder Pain',
          },
          advice: {
            'zh-HK': '御陽砭石罐 配合溫熱理療，溫灸肩井、大椎穴位，疏通肩頸經絡。',
            'zh-CN': '御阳砭石罐 配合温热理疗，温灸肩井、大椎穴位，疏通肩颈经络。',
            en: 'Use Yu Yang Bianstone Guan with warm therapy to warm Jianjing and Dazhui points and unblock neck-shoulder meridians.',
          },
          productSlug: '御陽砭石罐【專業版】',
          hotspots: [{ cx: 100, cy: 60, r: 12 }],
        },
        {
          id: 'back',
          iconSvg:
            '<svg viewBox="0 0 24 24" fill="none"><path d="M9 3v6l-3 4v8M15 3v6l3 4v8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
          label: {
            'zh-HK': '腰背疲勞',
            'zh-CN': '腰背疲劳',
            en: 'Back & Waist Fatigue',
          },
          advice: {
            'zh-HK': '御陽砭石罐 配合溫熱理療，溫灸命門、腎俞穴位，紓緩腰背疲勞，促進氣血循環。',
            'zh-CN': '御阳砭石罐 配合温热理疗，温灸命门、肾俞穴位，纾缓腰背疲劳，促进气血循环。',
            en: 'Use Yu Yang Bianstone Guan with warm therapy to warm Mingmen and Shenshu points, relieving back fatigue and promoting Qi-blood circulation.',
          },
          productSlug: '御陽近紅外線砭石腰帶',
          hotspots: [{ cx: 100, cy: 103, r: 12 }],
        },
        {
          id: 'cold',
          iconSvg:
            '<svg viewBox="0 0 24 24" fill="none"><path d="M12 2v20M12 2l-2.5 2.5M12 2l2.5 2.5M12 22l-2.5-2.5M12 22l2.5-2.5M2 12h20M2 12l2.5-2.5M2 12l2.5 2.5M22 12l-2.5-2.5M22 12l-2.5 2.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
          label: {
            'zh-HK': '手腳冰冷',
            'zh-CN': '手脚冰冷',
            en: 'Cold Hands & Feet',
          },
          advice: {
            'zh-HK': '御陽砭石罐 配合溫熱理療，溫敷勞宮、湧泉穴位，驅寒暖身，改善手腳冰冷。',
            'zh-CN': '御阳砭石罐 配合温热理疗，温敷劳宫、涌泉穴位，驱寒暖身，改善手脚冰冷。',
            en: 'Use Yu Yang Bianstone Guan with warm therapy to warm Laogong and Yongquan points, dispelling cold and warming hands and feet.',
          },
          productSlug: '御陽砭石片&玉石片紅光床塾',
          hotspots: [
            { cx: 46, cy: 144, r: 11 },
            { cx: 154, cy: 144, r: 11 },
          ],
        },
      ],
    },
  },
  {
    key: 'about',
    title: '關於扶陽堂',
    isActive: true,
    sortOrder: 4,
    contentJson: {
      eyebrow: {
        'zh-HK': '關於扶陽堂',
        'zh-CN': '关于扶阳堂',
        en: 'About Fu Yang Tong',
      },
      title: {
        'zh-HK': '傳承中醫精萃・創新養生之道',
        'zh-CN': '传承中医精萃・创新养生之道',
        en: 'Inheriting the Essence of TCM, Innovating the Way of Wellness',
      },
      p1: {
        'zh-HK': '扶陽堂國際有限公司成立於 2009 年，是集健康養生、美容產品之研發、生產、銷售與服務於一體的綜合性企業。我們以傳統中醫養生為根基，結合現代科學技術，針對亞健康人群，研發出享譽業界的「御陽」系列產品。',
        'zh-CN': '扶阳堂国际有限公司成立于 2009 年，是集健康养生、美容产品之研发、生产、销售与服务于一体的综合性企业。我们以传统中医养生为根基，结合现代科学技术，针对亚健康人群，研发出享誉业界的「御阳」系列产品。',
        en: 'Fu Yang Tong International Limited was founded in 2009. We are a comprehensive enterprise integrating R&D, production, sales and service of health and beauty products. Rooted in traditional Chinese medicine wellness and combined with modern science and technology, we developed the renowned Yu Yang series for sub-healthy individuals.',
      },
      p2: {
        'zh-HK': '御陽罐以「炙補元氣，刮通經絡」的亞健康調理技術為核心，善用熱能、紅外線、磁療、振動的同步物理能量，疏通經絡、溫補元氣、驅寒祛濕、舒鬆肌腱，激活細胞、面部美容、淋巴排毒，真正實現中醫養生的現代化。',
        'zh-CN': '御阳罐以「炙补元气，刮通经络」的亚健康调理技术为核心，善用热能、红外线、磁疗、振动的同步物理能量，疏通经络、温补元气、驱寒祛湿、舒松肌腱，激活细胞、面部美容、淋巴排毒，真正实现中医养生的现代化。',
        en: 'The Yu Yang Guan centers on the sub-health conditioning technique of \'warming and replenishing vital energy, scraping and unblocking meridians\'. It leverages synchronized physical energies including heat, infrared, magnetic therapy and vibration to unblock meridians, warm and tonify vital energy, dispel cold and dampness, relax tendons, activate cells, enhance facial beauty and promote lymphatic detoxification—truly modernizing TCM wellness.',
      },
      stats: [
        { num: '2009', label: { 'zh-HK': '始創年份', 'zh-CN': '始创年份', en: 'Founded' } },
        { num: '15+', label: { 'zh-HK': '年臨床實證', 'zh-CN': '年临床实证', en: 'Years of Clinical Evidence' } },
        { num: '1000+', label: { 'zh-HK': '真實調理案例', 'zh-CN': '真实调理案例', en: 'Real Conditioning Cases' } },
        { num: '多國', label: { 'zh-HK': '國際展會殊榮', 'zh-CN': '国际展会殊荣', en: 'International Exhibition Honors' } },
      ],
      gallery: [
        {
          src: '/images/about-exhibition.jpg',
          caption: {
            'zh-HK': '2012 年國際中醫藥展會・土耳其客戶與香港註冊中醫師潘良生合照',
            'zh-CN': '2012 年国际中医药展会・土耳其客户与香港注册中医师潘良生合照',
            en: '2012 International TCM Expo: Turkish client with Hong Kong Registered Chinese Medicine Practitioner Poon Leung-sang',
          },
        },
        {
          src: '/images/about-interview.jpg',
          caption: {
            'zh-HK': '2012 年澳門名牌大賞・千龍新聞網莫少玲主編採訪胡總、林總',
            'zh-CN': '2012 年澳门名牌大赏・千龙新闻网莫少玲主编采访胡总、林总',
            en: '2012 Macau Brand Awards: Qianlong News Network editor-in-chief Mok Siu-ling interviews Mr. Hu and Mr. Lam',
          },
        },
        {
          src: '/images/about-master.jpg',
          caption: {
            'zh-HK': '胡琴與國醫大師鄧鐵濤、胡木明合照',
            'zh-CN': '胡琴与国医大师邓铁涛、胡木明合照',
            en: 'Hu Qin with TCM master Deng Tietao and Hu Muming',
          },
        },
      ],
    },
  },
  {
    key: 'principle',
    title: '扶陽理念',
    isActive: true,
    sortOrder: 5,
    contentJson: {
      eyebrow: {
        'zh-HK': '核心原理・一目了然',
        'zh-CN': '核心原理・一目了然',
        en: 'The Science · At a Glance',
      },
      title: {
        'zh-HK': '一塊石頭，為何能養生？',
        'zh-CN': '一块石头，为何能养生？',
        en: 'Why Can a Single Stone Nourish Health?',
      },
      lead: {
        'zh-HK': '扶陽堂的核心，建立在一個中醫基本認知上——「血遇寒則凝，遇熱則行」。當體溫偏低（低於 36.5℃），血液循環變差，寒氣滯留經絡，便會出現肩頸酸痛、腰背僵硬、手腳冰冷等亞健康問題。御陽產品透過「熱能＋砭石＋紅光」三重物理能量協同作用，從根本升溫驅寒、疏通經絡。',
        'zh-CN': '扶阳堂的核心，建立在一个中医基本认知上——「血遇寒则凝，遇热则行」。当体温偏低（低于 36.5℃），血液循环变差，寒气滞留经络，便会出现肩颈酸痛、腰背僵硬、手脚冰冷等亚健康问题。御阳产品透过「热能＋砭石＋红光」三重物理能量协同作用，从根本升温驱寒、疏通经络。',
        en: 'Fu Yang Tong rests on a core TCM principle — \'blood congeals in cold and flows in warmth.\' When body temperature drops below 36.5°C, circulation weakens and cold stagnates in the meridians, causing stiff shoulders, sore backs and cold limbs. Our products combine three physical energies — Heat + Bianstone + Red Light — to raise temperature, expel cold and unblock the meridians at the source.',
      },
      leadImage: '/images/warm-stones.jpg',
      techTitle: {
        'zh-HK': '三大核心科技・三重養生力量',
        'zh-CN': '三大核心科技・三重养生力量',
        en: 'Three Core Technologies · Threefold Wellness',
      },
      techs: [
        {
          tag: {
            'zh-HK': '砭石',
            'zh-CN': '砭石',
            en: 'Bianstone',
          },
          title: {
            'zh-HK': '砭石遠紅外線與超聲波',
            'zh-CN': '砭石远红外线与超声波',
            en: 'Bianstone Far-Infrared & Ultrasound',
          },
          summary: {
            'zh-HK': '＝遠紅外線治療儀 ＋ 超聲波治療儀',
            'zh-CN': '＝远红外线治疗仪 ＋ 超声波治疗仪',
            en: '= Far-Infrared Device + Ultrasound Device',
          },
          desc: {
            'zh-HK': '砭石並非普通石頭，而是形成於數千萬年前的天然礦石（泗濱浮石），含數十種對人體有益的微量元素。它能釋放 5–20 微米遠紅外線，與人體自身紅外波段高度契合，如冬日暖陽穿透皮膚直達肌肉與經絡深處；接觸皮膚時更發出極廣頻率的超聲波脈衝，為細胞做深層「微按摩」，並與細胞同頻共振，促進血液循環、加速新陳代謝。',
            'zh-CN': '砭石并非普通石头，而是形成于数千万年前的天然矿石（泗滨浮石），含数十种对人体有益的微量元素。它能释放 5–20 微米远红外线，与人体自身红外波段高度契合，如冬日暖阳穿透皮肤直达肌肉与经络深处；接触皮肤时更发出极广频率的超声波脉冲，为细胞做深层「微按摩」，并与细胞同频共振，促进血液循环、加速新陈代谢。',
            en: 'Bianstone is no ordinary rock — it is Sibin floating stone formed tens of millions of years ago, rich in dozens of beneficial trace elements. It emits 5–20 micron far-infrared rays highly matched to the body\'s own spectrum, penetrating skin to reach muscles and meridians like winter sun. On contact it also emits broad-frequency ultrasonic pulses — a deep cellular \'micro-massage\' that resonates with cells, boosting circulation and metabolism.',
          },
          image: '',
        },
        {
          tag: {
            'zh-HK': '紅光',
            'zh-CN': '红光',
            en: 'Red Light',
          },
          title: {
            'zh-HK': '紅光／近紅外光療',
            'zh-CN': '红光／近红外光疗',
            en: 'Red / Near-Infrared Light Therapy',
          },
          summary: {
            'zh-HK': '用特定波長的光激活細胞，從細胞層面修復身體',
            'zh-CN': '用特定波长的光激活细胞，从细胞层面修复身体',
            en: 'Activate cells with specific wavelengths — repair at the cellular level',
          },
          desc: {
            'zh-HK': '扶陽堂紅光床墊等產品結合光子能量，運用紅光與近紅外線照射。這是一種光化學作用——促進細胞合成、加速受損神經再生、增加白血球吞噬作用。紅光透過皮膚滲透吸收，刺激經絡循行、輸送氣血，達到疏通經絡、調節臟腑、溫陽理氣、祛寒除濕之效。',
            'zh-CN': '扶阳堂红光床垫等产品结合光子能量，运用红光与近红外线照射。这是一种光化学作用——促进细胞合成、加速受损神经再生、增加白血球吞噬作用。红光透过皮肤渗透吸收，刺激经络循行、输送气血，达到疏通经络、调节脏腑、温阳理气、祛寒除湿之效。',
            en: 'Products such as the red-light mattress harness photon energy through red and near-infrared light. This photochemical action promotes cell synthesis, accelerates nerve regeneration and boosts white-cell phagocytosis. Absorbed through the skin, it stimulates meridian flow and Qi-blood transport — unblocking meridians, regulating organs, warming Yang and expelling cold and damp.',
          },
          image: '',
        },
        {
          tag: {
            'zh-HK': '碳纖維',
            'zh-CN': '碳纤维',
            en: 'Carbon Fibre',
          },
          title: {
            'zh-HK': '碳纖維溫熱技術',
            'zh-CN': '碳纤维温热技术',
            en: 'Carbon-Fibre Warming Technology',
          },
          summary: {
            'zh-HK': '安全、無輻射、精準控溫的養生熱源',
            'zh-CN': '安全、无辐射、精准控温的养生热源',
            en: 'A safe, radiation-free, precisely controlled wellness heat source',
          },
          desc: {
            'zh-HK': '扶陽堂產品採用碳纖維發熱線作為熱源：不產生電磁輻射，使用更安全；採 12V–24V 低電壓設計，安全可靠；精準將砭石加熱至 45–50℃（人體砭石溫法最適宜溫度），使熱能經砭石轉化為對人體有益的遠紅外輻射。',
            'zh-CN': '扶阳堂产品采用碳纤维发热线作为热源：不产生电磁辐射，使用更安全；采 12V–24V 低电压设计，安全可靠；精准将砭石加热至 45–50℃（人体砭石温法最适宜温度），使热能经砭石转化为对人体有益的远红外辐射。',
            en: 'Fu Yang Tong uses carbon-fibre heating wires: no electromagnetic radiation for safer use, a 12V–24V low-voltage design for reliability, and precise heating of the Bianstone to 45–50°C — the ideal temperature for the body — converting heat into beneficial far-infrared radiation through the stone.',
          },
          image: '',
        },
      ],
      synergyEyebrow: {
        'zh-HK': '扶陽堂 · 科技解構',
        'zh-CN': '扶阳堂 · 科技解构',
        en: 'Fu Yang Tong · Tech Deconstructed',
      },
      synergyTitle: {
        'zh-HK': '三種科技如何協同作用？',
        'zh-CN': '三种科技如何协同作用？',
        en: 'How Do the Three Technologies Work Together?',
      },
      synergySubtitle: {
        'zh-HK': '由熱能到光能，四道工序層層遞進，把溫度化成看得見的舒緩',
        'zh-CN': '由热能到光能，四道工序层层递进，把温度化成看得见的舒缓',
        en: 'From thermal to light energy, four progressive steps turn warmth into visible relief.',
      },
      flowTitle: {
        'zh-HK': '三種科技如何協同作用？',
        'zh-CN': '三种科技如何协同作用？',
        en: 'How Do the Three Technologies Work Together?',
      },
      flow: [
        {
          'zh-HK': '碳纖維加熱・提供熱能',
          'zh-CN': '碳纤维加热・提供热能',
          en: 'Carbon-fibre heating · provides heat',
        },
        {
          'zh-HK': '砭石升溫・將熱能轉化為遠紅外線',
          'zh-CN': '砭石升温・将热能转化为远红外线',
          en: 'Bianstone warms up · converts heat into far-infrared',
        },
        {
          'zh-HK': '遠紅外線＋超聲波・深入經絡疏通氣血',
          'zh-CN': '远红外线＋超声波・深入经络疏通气血',
          en: 'Far-infrared + ultrasound · penetrate meridians, move Qi-blood',
        },
        {
          'zh-HK': '紅光照射・激活細胞促進修復',
          'zh-CN': '红光照射・激活细胞促进修复',
          en: 'Red-light therapy · activates cells, aids repair',
        },
      ],
      flowResult: {
        'zh-HK': '溫通經絡 → 活血化瘀 → 驅風祛濕 → 消除疲勞',
        'zh-CN': '温通经络 → 活血化瘀 → 驱风祛湿 → 消除疲劳',
        en: 'Warm the meridians → Move blood → Expel wind & damp → Relieve fatigue',
      },
      benefitsTitle: {
        'zh-HK': '告別這些困擾，從提升體溫開始',
        'zh-CN': '告别这些困扰，从提升体温开始',
        en: 'Say Goodbye to These Troubles — Start by Raising Your Temperature',
      },
      painCta: {
        'zh-HK': '立即了解四大科技如何守護你 →',
        'zh-CN': '立即了解四大科技如何守护你 →',
        en: 'See how the four technologies protect you →',
      },
      benefits: [
        {
          'zh-HK': '長期伏案導致的肩頸酸痛、腰背僵硬',
          'zh-CN': '长期伏案导致的肩颈酸痛、腰背僵硬',
          en: 'Neck & back stiffness from desk work',
        },
        {
          'zh-HK': '手腳冰冷、怕冷的「陽虛」體質',
          'zh-CN': '手脚冰冷、怕冷的「阳虚」体质',
          en: 'Cold limbs and a \'Yang-deficient\', cold-prone constitution',
        },
        {
          'zh-HK': '疲勞不適、精神不濟',
          'zh-CN': '疲劳不适、精神不济',
          en: 'Fatigue and low energy',
        },
        {
          'zh-HK': '五十肩、關節疼痛',
          'zh-CN': '五十肩、关节疼痛',
          en: 'Frozen shoulder and joint pain',
        },
        {
          'zh-HK': '睡眠品質差、頭痛失眠',
          'zh-CN': '睡眠品质差、头痛失眠',
          en: 'Poor sleep, headaches and insomnia',
        },
      ],
      painTips: [
        {
          'zh-HK': '遠紅外線深層滲透，放鬆繃緊肌肉',
          'zh-CN': '远红外线深层渗透，放松绷紧肌肉',
          en: 'Far-infrared penetrates deeply to relax tense muscles',
        },
        {
          'zh-HK': '持續溫熱，由內而外提升體溫',
          'zh-CN': '持续温热，由内而外提升体温',
          en: 'Continuous warmth raises body temperature from within',
        },
        {
          'zh-HK': '加速氣血循環，喚醒身體能量',
          'zh-CN': '加速气血循环，唤醒身体能量',
          en: 'Accelerates Qi-blood circulation and wakes up energy',
        },
        {
          'zh-HK': '溫通關節，改善活動幅度',
          'zh-CN': '温通关节，改善活动幅度',
          en: 'Warms joints and improves range of motion',
        },
        {
          'zh-HK': '舒緩神經緊張，助入眠更安穩',
          'zh-CN': '舒缓神经紧张，助入眠更安稳',
          en: 'Soothes nervous tension for more restful sleep',
        },
      ],
    },
  },
  {
    key: 'experts',
    title: '專家見證',
    isActive: true,
    sortOrder: 7,
    contentJson: {
      eyebrow: {
        'zh-HK': '雙專家權威見證',
        'zh-CN': '双专家权威见证',
        en: 'Dual-Expert Testimonials',
      },
      title: {
        'zh-HK': '中醫智慧 × 現代物理治療',
        'zh-CN': '中医智慧 × 现代物理治疗',
        en: 'TCM Wisdom × Modern Physiotherapy',
      },
      tcmLabel: {
        'zh-HK': '中醫師角度',
        'zh-CN': '中医师角度',
        en: 'TCM Perspective',
      },
      ptLabel: {
        'zh-HK': '物理治療師角度',
        'zh-CN': '物理治疗师角度',
        en: 'Physiotherapist Perspective',
      },
      recommendText: {
        'zh-HK': '推薦產品',
        'zh-CN': '推荐产品',
        en: 'Recommended',
      },
      experts: [
        {
          id: 'tcm-1',
          type: 'tcm',
          videoUrl: 'https://assets.mixkit.co/videos/preview/mixkit-woman-practicing-yoga-in-the-morning-42561-large.mp4',
          name: {
            'zh-HK': '張醫師',
            'zh-CN': '张医师',
            en: 'Dr. Cheung',
          },
          title: {
            'zh-HK': '資深中醫師',
            'zh-CN': '资深中医师',
            en: 'Senior TCM Practitioner',
          },
          quote: {
            'zh-HK': '砭石溫熱療法能有效溫通經絡，祛除體內寒濕，尤其適合陽虛怕冷的都市人日常調理。',
            'zh-CN': '砭石温热疗法能有效温通经络，祛除体内寒湿，尤其适合阳虚怕冷的都市人日常调理。',
            en: 'Bianstone thermal therapy effectively warms the meridians and expels internal cold and damp — ideal daily care for cold-prone, Yang-deficient city dwellers.',
          },
        },
        {
          id: 'pt-1',
          type: 'pt',
          videoUrl: 'https://assets.mixkit.co/videos/preview/mixkit-man-doing-stretches-on-a-yoga-mat-43537-large.mp4',
          name: {
            'zh-HK': '陳治療師',
            'zh-CN': '陈治疗师',
            en: 'Therapist Chan',
          },
          title: {
            'zh-HK': '註冊物理治療師',
            'zh-CN': '注册物理治疗师',
            en: 'Registered Physiotherapist',
          },
          quote: {
            'zh-HK': '深層筋膜放鬆結合熱傳導，能顯著緩解肌肉緊張，加速勞損部位的血液循環與修復。',
            'zh-CN': '深层筋膜放松结合热传导，能显著缓解肌肉紧张，加速劳损部位的血液循环与修复。',
            en: 'Deep fascia release with thermal conduction significantly eases muscle tension and speeds circulation and recovery in strained areas.',
          },
        },
      ],
    },
  },
  {
    key: 'product-funnel',
    title: '產品系列',
    isActive: true,
    sortOrder: 6,
    contentJson: {
      title: {
        'zh-HK': '御陽產品系列',
        'zh-CN': '御阳产品系列',
        en: 'Yu Yang Product Series',
      },
      subtitle: {
        'zh-HK': '扶陽堂精選養生保健產品，為銀髮一族及家庭而設。',
        'zh-CN': '扶阳堂精选养生保健产品，为银发一族及家庭而设。',
        en: 'Fu Yang Tong curated wellness products for seniors and families.',
      },
      tiers: [],
    },
  },
  {
    key: 'authentic',
    title: '正宗聲明',
    isActive: true,
    sortOrder: 8,
    contentJson: {
      sealImage: '/images/logo.png',
      eyebrow: {
        'zh-HK': '正宗聲明・謹防假冒',
        'zh-CN': '正宗声明・谨防假冒',
        en: 'Authenticity Statement · Beware of Counterfeits',
      },
      title: {
        'zh-HK': '認住御陽® 商標，才是正宗扶陽堂產品',
        'zh-CN': '认准御阳® 商标，才是正宗扶阳堂产品',
        en: 'Look for the Yu Yang® Trademark for Genuine Fu Yang Tong Products',
      },
      intro: {
        'zh-HK': '御陽罐乃扶陽堂原創研發，市面淘寶、拼多多等平台充斥大量低價仿冒「A 貨」，用料粗劣、砭石成份不明、加熱不安全，不但無法達到溫通經絡之效，更可能危害健康。',
        'zh-CN': '御阳罐乃扶阳堂原创研发，市面淘宝、拼多多等平台充斥大量低价仿冒「A 货」，用料粗劣、砭石成份不明、加热不安全，不但无法达到温通经络之效，更可能危害健康。',
        en: 'The Yu Yang Guan is originally developed by Fu Yang Tong. The market is flooded with low-price counterfeit \'A-grade\' goods on platforms like Taobao and Pinduoduo, using inferior materials with unknown Bian stone composition and unsafe heating. They cannot achieve the effect of warming and unblocking meridians and may even harm your health.',
      },
      points: [
        {
          icon: 'shield',
          title: {
            'zh-HK': '正宗原創・源頭直營',
            'zh-CN': '正宗原创・源头直营',
            en: 'Genuine Original · Direct from Source',
          },
          desc: {
            'zh-HK': '扶陽堂為御陽系列唯一原創與正版授權方，所有產品均可經官方門市與正規渠道追溯來源。',
            'zh-CN': '扶阳堂为御阳系列唯一原创与正版授权方，所有产品均可经官方门市与正规渠道追溯来源。',
            en: 'Fu Yang Tong is the sole original creator and licensed brand of the Yu Yang series. All products can be traced through official stores and authorized channels.',
          },
        },
        {
          icon: 'alert',
          title: {
            'zh-HK': '拒絕 A 貨仿冒品',
            'zh-CN': '拒绝 A 货仿冒品',
            en: 'Reject Counterfeit A-Grade Goods',
          },
          desc: {
            'zh-HK': '淘寶、拼多多低價「御陽罐」多為仿冒品，砭石以普通石料充數，加熱線無安全認證，切勿貪平購買。',
            'zh-CN': '淘宝、拼多多低价「御阳罐」多为仿冒品，砭石以普通石料充数，加热线无安全认证，切勿贪平购买。',
            en: 'Low-price \'Yu Yang Guan\' products on Taobao and Pinduoduo are mostly counterfeit, using ordinary stone as Bian stone and non-certified heating wires. Do not risk buying them for a bargain.',
          },
        },
        {
          icon: 'stamp',
          title: {
            'zh-HK': '認明御陽商標與授權',
            'zh-CN': '认明御阳商标与授权',
            en: 'Identify the Yu Yang Trademark and Authorization',
          },
          desc: {
            'zh-HK': '正品包裝均印有御陽商標及扶陽堂授權資訊，購買前請認明，或親臨門市體驗選購。',
            'zh-CN': '正品包装均印有御阳商标及扶阳堂授权信息，购买前请认明，或亲临门市体验选购。',
            en: 'Genuine packaging bears the Yu Yang trademark and Fu Yang Tong authorization information. Please verify before purchase, or visit our stores to experience and buy.',
          },
        },
      ],
      compareTitle: {
        'zh-HK': '正品 vs 仿冒品',
        'zh-CN': '正品 vs 仿冒品',
        en: 'Genuine vs Counterfeit',
      },
      genuineLabel: {
        'zh-HK': '御陽正品',
        'zh-CN': '御阳正品',
        en: 'Genuine Yu Yang',
      },
      fakeLabel: {
        'zh-HK': '淘寶／拼多多 A 貨',
        'zh-CN': '淘宝／拼多多 A 货',
        en: 'Taobao / Pinduoduo A-Grade',
      },
      compare: [
        {
          label: {
            'zh-HK': '砭石材質',
            'zh-CN': '砭石材质',
            en: 'Bian Stone Material',
          },
          genuine: {
            'zh-HK': '天然泗濱浮石・含數十種微量元素',
            'zh-CN': '天然泗滨浮石・含数十种微量元素',
            en: 'Natural Si Bin floating stone · contains dozens of trace elements',
          },
          fake: {
            'zh-HK': '普通石料充數・成份不明',
            'zh-CN': '普通石料充数・成份不明',
            en: 'Ordinary stone filler · unknown composition',
          },
        },
        {
          label: {
            'zh-HK': '加熱技術',
            'zh-CN': '加热技术',
            en: 'Heating Technology',
          },
          genuine: {
            'zh-HK': '碳纖維發熱・無電磁輻射・精準控溫',
            'zh-CN': '碳纤维发热・无电磁辐射・精准控温',
            en: 'Carbon fiber heating · no electromagnetic radiation · precise temperature control',
          },
          fake: {
            'zh-HK': '劣質電熱線・溫控不穩・存安全風險',
            'zh-CN': '劣质电热线・温控不稳・存安全风险',
            en: 'Inferior heating wire · unstable temperature control · safety risk',
          },
        },
        {
          label: {
            'zh-HK': '遠紅外效能',
            'zh-CN': '远红外效能',
            en: 'Far-Infrared Performance',
          },
          genuine: {
            'zh-HK': '5–20 微米・與人體高度契合',
            'zh-CN': '5–20 微米・与人体高度契合',
            en: '5–20 microns · highly compatible with the human body',
          },
          fake: {
            'zh-HK': '波段不明・效能無保障',
            'zh-CN': '波段不明・效能无保障',
            en: 'Unknown wavelength · performance not guaranteed',
          },
        },
        {
          label: {
            'zh-HK': '售後保障',
            'zh-CN': '售后保障',
            en: 'After-Sales Support',
          },
          genuine: {
            'zh-HK': '官方保養・門市體驗・專業指導',
            'zh-CN': '官方保养・门市体验・专业指导',
            en: 'Official warranty · in-store experience · professional guidance',
          },
          fake: {
            'zh-HK': '無保養・無正規售後',
            'zh-CN': '无保养・无正规售后',
            en: 'No warranty · no formal after-sales',
          },
        },
      ],
      note: {
        'zh-HK': '如有懷疑，歡迎透過官方 WhatsApp 或親臨門市核實真偽。',
        'zh-CN': '如有怀疑，欢迎透过官方 WhatsApp 或亲临门市核实真伪。',
        en: 'If in doubt, please verify authenticity through our official WhatsApp or visit our store.',
      },
    },
  },
  {
    key: 'cases',
    title: '真實案例',
    isActive: true,
    sortOrder: 9,
    contentJson: {
      eyebrow: {
        'zh-HK': '真實調理案例',
        'zh-CN': '真实调理案例',
        en: 'Real Conditioning Cases',
      },
      title: {
        'zh-HK': '看得見的成效・都市人的家用保健師',
        'zh-CN': '看得见的成效・都市人的家用保健师',
        en: 'Visible Results · Your Home Wellness Companion',
      },
      intro: {
        'zh-HK': '以下案例由香港註冊中醫師潘良新及各大健康中心、裕華國貨等正規渠道提供，均為真實用戶回饋，僅供參考，個別效果因人而異。',
        'zh-CN': '以下案例由香港注册中医师潘良新及各大健康中心、裕华国货等正规渠道提供，均为真实用户回馈，仅供参考，个别效果因人而异。',
        en: 'The following cases are provided by Hong Kong Registered Chinese Medicine Practitioner Poon Leung-sun, major wellness centers, and Yue Hwa Department Store. They are real user feedback for reference only; individual results may vary.',
      },
      sourceLabel: {
        'zh-HK': '案例來源',
        'zh-CN': '案例来源',
        en: 'Case Source',
      },
      list: [
        {
          tag: {
            'zh-HK': '面癱',
            'zh-CN': '面瘫',
            en: 'Facial Paralysis',
          },
          title: {
            'zh-HK': '御陽罐輔助改善面癱',
            'zh-CN': '御阳罐辅助改善面瘫',
            en: 'Yu Yang Guan Assisted Improvement of Facial Paralysis',
          },
          person: {
            'zh-HK': '陳女士・50 歲',
            'zh-CN': '陈女士・50 岁',
            en: 'Ms. Chan · Age 50',
          },
          content: {
            'zh-HK': '十年前睡醒自覺面部不適，嘴角歪斜、眼瞼跳動，經數月針藥治療三十多次仍無大進展。改以御陽罐持續溫灸調理後，面部僵硬與歪斜情況逐步改善。',
            'zh-CN': '十年前睡醒自觉面部不适，嘴角歪斜、眼睑跳动，经数月针药治疗三十多次仍无大进展。改以御阳罐持续温灸调理后，面部僵硬与歪斜情况逐步改善。',
            en: 'Ten years ago, she woke up with facial discomfort, a crooked mouth corner and twitching eyelids. After more than thirty sessions of acupuncture and herbal medicine over several months, there was little improvement. After switching to continuous warm moxibustion conditioning with the Yu Yang Guan, facial stiffness and crookedness gradually improved.',
          },
          source: {
            'zh-HK': '香港註冊中醫師：潘良新',
            'zh-CN': '香港注册中医师：潘良新',
            en: 'Hong Kong Registered Chinese Medicine Practitioner: Poon Leung-sun',
          },
        },
        {
          tag: {
            'zh-HK': '經痛',
            'zh-CN': '经痛',
            en: 'Menstrual Pain',
          },
          title: {
            'zh-HK': '溫灸腹部・舒緩經前劇痛',
            'zh-CN': '温灸腹部・舒缓经前剧痛',
            en: 'Warm Moxibustion on Abdomen · Relieving Severe Pre-Menstrual Pain',
          },
          person: {
            'zh-HK': '陳太女兒・大學生',
            'zh-CN': '陈太女儿・大学生',
            en: "Mrs. Chan's daughter · University student",
          },
          content: {
            'zh-HK': '每次經前疼痛劇烈，需服止痛藥方能上學。於月經前五天每天邊看電視邊用御陽罐溫灸腹部十分鐘，疼痛大減，不用吃止痛藥也能上學。',
            'zh-CN': '每次经前疼痛剧烈，需服止痛药方能上学。于月经前五天每天边看电视边用御阳罐温灸腹部十分钟，疼痛大减，不用吃止痛药也能上学。',
            en: 'She suffered severe pain before each period and had to take painkillers to attend school. Five days before menstruation, she used the Yu Yang Guan to warm her abdomen for ten minutes daily while watching TV. The pain was greatly reduced and she could go to school without painkillers.',
          },
          source: {
            'zh-HK': '香港註冊中醫師：潘良新',
            'zh-CN': '香港注册中医师：潘良新',
            en: 'Hong Kong Registered Chinese Medicine Practitioner: Poon Leung-sun',
          },
        },
        {
          tag: {
            'zh-HK': '膝痛',
            'zh-CN': '膝痛',
            en: 'Knee Pain',
          },
          title: {
            'zh-HK': '夜半膝痛・溫灸漸消',
            'zh-CN': '夜半膝痛・温灸渐消',
            en: 'Midnight Knee Pain · Gradually Relieved by Warm Moxibustion',
          },
          person: {
            'zh-HK': '利太・53 歲',
            'zh-CN': '利太・53 岁',
            en: 'Mrs. Lee · Age 53',
          },
          content: {
            'zh-HK': '每晚睡至二三點因膝關節疼痛而痛醒，情況持續超過一年，冷天尤甚。每晚用御陽罐溫灸膝部十至十五分鐘後，疼痛漸減。',
            'zh-CN': '每晚睡至二三点因膝关节疼痛而痛醒，情况持续超过一年，冷天尤甚。每晚用御阳罐温灸膝部十至十五分钟后，疼痛渐减。',
            en: "Every night she was woken by knee joint pain around two or three o'clock. The condition lasted more than a year and was worse in cold weather. After using the Yu Yang Guan to warm her knees for ten to fifteen minutes each night, the pain gradually decreased.",
          },
          source: {
            'zh-HK': '香港註冊中醫師：潘良新',
            'zh-CN': '香港注册中医师：潘良新',
            en: 'Hong Kong Registered Chinese Medicine Practitioner: Poon Leung-sun',
          },
        },
        {
          tag: {
            'zh-HK': '夜尿',
            'zh-CN': '夜尿',
            en: 'Nocturia',
          },
          title: {
            'zh-HK': '溫灸下腹・改善夜尿頻繁',
            'zh-CN': '温灸下腹・改善夜尿频繁',
            en: 'Warm Moxibustion on Lower Abdomen · Improving Frequent Night Urination',
          },
          person: {
            'zh-HK': '鄧伯・78 歲',
            'zh-CN': '邓伯・78 岁',
            en: 'Mr. Tang · Age 78',
          },
          content: {
            'zh-HK': '每晚夜尿頻繁，隔一小時多便要如廁一次，冬天更甚。早午晚以御陽罐溫灸小腹關元、氣海、中極等穴各十分鐘，感覺舒服，夜尿次數逐漸減少。',
            'zh-CN': '每晚夜尿频繁，隔一小时多便要如厕一次，冬天更甚。早午晚以御阳罐温灸小腹关元、气海、中极等穴各十分钟，感觉舒服，夜尿次数逐渐减少。',
            en: 'He urinated frequently every night, needing to go every hour or so, especially in winter. Using the Yu Yang Guan to warm the Guanyuan, Qihai and Zhongji points on the lower abdomen for ten minutes each morning, noon and evening, he felt comfortable and the number of night-time urinations gradually decreased.',
          },
          source: {
            'zh-HK': '香港註冊中醫師：潘良新',
            'zh-CN': '香港注册中医师：潘良新',
            en: 'Hong Kong Registered Chinese Medicine Practitioner: Poon Leung-sun',
          },
        },
        {
          tag: {
            'zh-HK': '肩頸失眠',
            'zh-CN': '肩颈失眠',
            en: 'Neck-Shoulder Pain & Insomnia',
          },
          title: {
            'zh-HK': '溫灸肩井・擺脫痛症與失眠',
            'zh-CN': '温灸肩井・摆脱痛症与失眠',
            en: 'Warm Moxibustion on Jianjing · Free from Pain and Insomnia',
          },
          person: {
            'zh-HK': '袁小姐・47 歲・會計',
            'zh-CN': '袁小姐・47 岁・会计',
            en: 'Miss Yuen · Age 47 · Accountant',
          },
          content: {
            'zh-HK': '工作生活壓力大，常肩酸背痛甚至半夜失眠。每晚溫灸肩井、大椎、風池、安眠等穴位，使用一個月後，徹底擺脫痛症與失眠困擾。',
            'zh-CN': '工作生活压力大，常肩酸背痛甚至半夜失眠。每晚温灸肩井、大椎、风池、安眠等穴位，使用一个月后，彻底摆脱痛症与失眠困扰。',
            en: 'Work and life stress caused frequent sore shoulders and back pain, even insomnia in the middle of the night. After warming the Jianjing, Dazhui, Fengchi and Anmian points every night for a month, she completely got rid of pain and insomnia.',
          },
          source: {
            'zh-HK': '天恩整全健康中心',
            'zh-CN': '天恩整全健康中心',
            en: 'Tin Yan Holistic Health Centre',
          },
        },
        {
          tag: {
            'zh-HK': '行氣活血',
            'zh-CN': '行气活血',
            en: 'Qi & Blood Circulation',
          },
          title: {
            'zh-HK': '溫推膀胱經・行氣活血更精神',
            'zh-CN': '温推膀胱经・行气活血更精神',
            en: 'Warm Push on Bladder Meridian · Better Qi, Blood and Energy',
          },
          person: {
            'zh-HK': '陳太',
            'zh-CN': '陈太',
            en: 'Mrs. Chan',
          },
          content: {
            'zh-HK': '購買御陽罐三個多月，每日於膀胱經溫推及氣海、關元溫灸，身體感覺行氣活血、十分舒服，人也精神多了。',
            'zh-CN': '购买御阳罐三个多月，每日于膀胱经温推及气海、关元温灸，身体感觉行气活血、十分舒服，人也精神多了。',
            en: 'After purchasing the Yu Yang Guan for more than three months, she does warm pushing along the bladder meridian and warm moxibustion on Qihai and Guanyuan every day. Her body feels qi and blood circulating smoothly, very comfortable, and she is more energetic.',
          },
          source: {
            'zh-HK': '裕華國貨佐敦總店',
            'zh-CN': '裕华国货佐敦总店',
            en: 'Yue Hwa Department Store Jordan Main Store',
          },
        },
      ],
    },
  },
  {
    key: 'store-locator',
    title: '門市地點',
    isActive: true,
    sortOrder: 10,
    contentJson: {
      eyebrow: {
        'zh-HK': '門市地點',
        'zh-CN': '门市地点',
        en: 'Store Locations',
      },
      title: {
        'zh-HK': '親臨體驗・正宗保證',
        'zh-CN': '亲临体验・正宗保证',
        en: 'Visit Us · Authenticity Guaranteed',
      },
      ctaText: {
        'zh-HK': '親臨體驗，感受即時的深層發熱與筋膜鬆解',
        'zh-CN': '亲临体验，感受即时的深层发热与筋膜松解',
        en: 'Visit us and feel the instant deep warming and fascial release',
      },
      stores: [
        {
          name: {
            'zh-HK': '旺角金雞廣場總店',
            'zh-CN': '旺角金鸡广场总店',
            en: 'Mong Kok Golden Plaza Flagship Store',
          },
          address: {
            'zh-HK': '香港九龍旺角洗衣街 39-55 號金雞廣場 26 樓 2602 室',
            'zh-CN': '香港九龙旺角洗衣街 39-55 号金鸡广场 26 楼 2602 室',
            en: 'Room 2602, 26/F, Golden Plaza, 39-55 Sai Yee Street, Mong Kok, Kowloon, Hong Kong',
          },
          hours: {
            'zh-HK': '10:00 - 20:00',
            'zh-CN': '10:00 - 20:00',
            en: '10:00 - 20:00',
          },
          mapUrl: 'https://maps.google.com/?q=旺角金雞廣場',
        },
        {
          name: {
            'zh-HK': '裕華國貨專櫃',
            'zh-CN': '裕华国货专柜',
            en: 'Yue Hwa Department Store Counter',
          },
          address: {
            'zh-HK': '佐敦彌敦道 301-309 號裕華國貨',
            'zh-CN': '佐敦弥敦道 301-309 号裕华国货',
            en: 'Yue Hwa Department Store, 301-309 Nathan Road, Jordan',
          },
          hours: {
            'zh-HK': '10:00 - 22:00',
            'zh-CN': '10:00 - 22:00',
            en: '10:00 - 22:00',
          },
          mapUrl: 'https://maps.google.com/?q=佐敦裕華國貨',
        },
      ],
    },
  },
  {
    key: 'footer',
    title: '頁尾',
    isActive: true,
    sortOrder: 11,
    contentJson: {
      slogan: {
        'zh-HK': '身體的溫度，決定了健康的高度',
        'zh-CN': '身体的温度，决定了健康的高度',
        en: 'Body Temperature Determines the Height of Health',
      },
      desc: {
        'zh-HK': '扶陽堂——用科技傳承中醫智慧，讓養生變得簡單、安全、有效。',
        'zh-CN': '扶阳堂——用科技传承中医智慧，让养生变得简单、安全、有效。',
        en: 'Fu Yang Tong — Using technology to pass on TCM wisdom, making wellness simple, safe and effective.',
      },
      brandSince: {
        'zh-HK': '始創於 2009',
        'zh-CN': '始创于 2009',
        en: 'Founded in 2009',
      },
      address: {
        'zh-HK': '香港九龍旺角洗衣街 39-55 號金雞廣場 26 樓 2602 室',
        'zh-CN': '香港九龙旺角洗衣街 39-55 号金鸡广场 26 楼 2602 室',
        en: 'Room 2602, 26/F, Golden Plaza, 39-55 Sai Yee Street, Mong Kok, Kowloon, Hong Kong',
      },
      phone: '(852) 2350 9118',
      whatsapp: '5120 8911',
      rights: {
        'zh-HK': '版權所有・翻印必究',
        'zh-CN': '版权所有・翻印必究',
        en: 'All Rights Reserved · Reproduction Prohibited',
      },
      termsLabel: {
        'zh-HK': '使用條款',
        'zh-CN': '使用条款',
        en: 'Terms of Use',
      },
      privacyLabel: {
        'zh-HK': '隱私政策',
        'zh-CN': '隐私政策',
        en: 'Privacy Policy',
      },
      shippingLabel: {
        'zh-HK': '配送說明',
        'zh-CN': '配送说明',
        en: 'Shipping Info',
      },
    },
  },
  {
    key: 'popup',
    title: '進站推薦彈窗',
    isActive: true,
    sortOrder: 100,
    contentJson: {
      isActive: true,
      delaySeconds: 15,
      productImage: 'https://fuyangtong-api.jimsbond007.workers.dev/api/public/assets/media/81a5cfc0-774a-4772-b952-6e7ba0f89e63.webp',
      productName: {
        'zh-HK': '御陽近紅外線砭石腰帶（粉紅色）',
        'zh-CN': '御阳近红外线砭石腰带（粉红色）',
        en: 'Yu Yang Near-Infrared Bianstone Belt (Pink)',
      },
      eyebrow: {
        'zh-HK': '扶陽堂 · 御陽砭石系列',
        'zh-CN': '扶阳堂 · 御阳砭石系列',
        en: 'Fu Yang Tang · Yu Yang Bianstone Series',
      },
      tagline: {
        'zh-HK': '免刮痧，戴著就在調理',
        'zh-CN': '免刮痧，戴着就在调理',
        en: 'Wear it and let it work — no scraping needed',
      },
      benefits: [
        {
          'zh-HK': '免刮痧，全天候被動理療，不佔用你的時間',
          'zh-CN': '免刮痧，全天候被动理疗，不占用你的时间',
          en: 'No scraping needed — passive therapy around the clock',
        },
        {
          'zh-HK': '不只顧腰，肩頸、腹部、關節都能用',
          'zh-CN': '不只顾腰，肩颈、腹部、关节都能用',
          en: 'Not just for your waist — also shoulders, abdomen and joints',
        },
        {
          'zh-HK': '出門、辦公、睡覺都能戴著，理療融入日常',
          'zh-CN': '出门、办公、睡觉都能戴着，理疗融入日常',
          en: 'Wear it out, at work, or while sleeping — therapy becomes daily routine',
        },
      ],
      ctaText: {
        'zh-HK': '立即查看產品 →',
        'zh-CN': '立即查看产品 →',
        en: 'View Product →',
      },
      ctaHref: '/products/%E5%BE%A1%E9%99%BD%E8%BF%91%E7%B4%85%E5%A4%96%E7%B7%9A%E7%A0%AD%E7%9F%B3%E8%85%B0%E5%B8%B6%EF%BC%88%E7%B2%89%E7%B4%85%E8%89%B2%EF%BC%89',
      price: '',
      excludePaths: ['/products/%E5%BE%A1%E9%99%BD%E8%BF%91%E7%B4%85%E5%A4%96%E7%B7%9A%E7%A0%AD%E7%9F%B3%E8%85%B0%E5%B8%B6%EF%BC%88%E7%B2%89%E7%B4%85%E8%89%B2%EF%BC%89'],
    },
  },
];

